import { HRKeyResponsibilityArea } from "./HRKeyResponsibilityArea";
import {HRKraHRGoal} from "./HRKraHRGoal";
import {UnitKRA} from "./UnitKRA";
import {JSonSerializer} from "../../../model/JSonSerializer";
import {HRGoalKPI} from "./HRGoalKPI";

export class HRKeyResponsibilityAreaAggregation {
    kra = new HRKeyResponsibilityArea();
    units = new Array<UnitKRA>();
    links = new Array<HRKraHRGoal>();


    _createFromArray(propertyName: string, data: any) {
        const serializer = new JSonSerializer();
        if ('units' === propertyName) {
            for (const bean of <UnitKRA[]> data) {
                const tmp = new UnitKRA();
                serializer.deserialize(bean, tmp);
                this.units.push(tmp);
            }
        }
        if ('links' === propertyName) {
            for (const bean of <HRKraHRGoal[]> data) {
                const tmp = new HRKraHRGoal();
                serializer.deserialize(bean, tmp);
                this.links.push(tmp);
            }
        }

    }

}

